function Spacer() {
  return <div className="spacer"></div>;
}

export default Spacer;
